import React from 'react';

const PROMPT_TIPS = [
  'Be specific and clear about your requirements',
  'Include relevant context or background information',
  'Specify your preferred format or style of response',
  'Break down complex requests into smaller parts',
  'Use examples when possible to illustrate your needs'
];

export function PromptTips() {
  return (
    <div className="bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 p-8 rounded-xl shadow-lg mb-8 border border-blue-100">
      <h3 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-3">
        <span className="text-blue-600">💡</span>
        <span className="bg-gradient-to-r from-blue-600 to-purple-600 inline-block text-transparent bg-clip-text">
          Tips for Better Prompts
        </span>
      </h3>
      <ul className="space-y-4">
        {PROMPT_TIPS.map((tip, index) => (
          <li key={index} className="flex items-start gap-3">
            <span className="text-blue-500 font-bold mt-1">•</span>
            <span className="text-gray-700">{tip}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}